// extracted by mini-css-extract-plugin
export default {"header":"DetailedHeader_header__+sTan","header__logo":"DetailedHeader_header__logo__D8kCJ"};